class SpliderComponent extends HTMLElement {
    constructor() {
      super();
      this.options = {};
      this.addedExtensions = {};
    }
  
    connectedCallback() {
      // Initialize immediately if document is already loaded
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.initSplide());
      } else {
        this.initSplide();
      }
    }
  
    extractOptions() {
      this.options = JSON.parse(this.dataset.options || '{}');
      this.autoScroll = Object.prototype.hasOwnProperty.call(this.dataset, 'autoScroll');
      this.playOnIntersection = Object.prototype.hasOwnProperty.call(this.dataset, 'playOnView');
  
      if (this.playOnIntersection) {
        this.options = {
          ...this.options,
          intersection: {
            inView: {
              autoScroll: true,
              autoplay: true
            },
            outView: {
              autoScroll: false,
              autoplay: false
            }
          }
        };
      }
    }
  
    initSplide() {
      this.extractOptions();  
      // A lone banner must not loop or respond to swipe/drag gestures.
      if (this.classList.contains('carousel-wrapper') &&
          this.querySelectorAll('.splide__list > .splide__slide:not(.splide__slide--clone)').length === 1) {
        this.options = {
          ...this.options,
          type: 'slide',
          perPage: 1,
          autoplay: false,
          drag: false,
          arrows: false,
          pagination: false
        };
      }
      this.splide = new Splide(this, this.options).mount(this.addedExtensions);
    }
  }
  
  customElements.define('splider-component', SpliderComponent);
